export const environment = {
    production: false,
    hmr: false,
    dynamicTheme: false,
    appConfig: 'appconfig.staging.json',
};
